import React, { useEffect, useState } from 'react'
import ModalContainer from '../../common/modal/ModalContainer'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { useDispatch } from 'react-redux'
import { closeLoader, openLoader } from '../../redux_toolkit/Loader'
import {
    addNewFavouriteFolder,
    getFolderById,
    updateFavouriteFolder
} from '../../services/v3/Favourite/FavouriteService'
import { printApiError } from '../../helpers/Util'

const AddFolderModal = ({
    isShowModal,
    closeModal,
    fetchFolderList,
    folderId,
    setSelectedId
}) => {
    const [error, setError] = useState(false)
    const [folderName, setFolderName] = useState('')
    const [description, setDescription] = useState('')
    const [folderInfo, setFolderInfo] = useState(null)
    const dispatch = useDispatch()

    useEffect(() => {
        if (folderId) {
            fetchFolderById()
        }
    }, [folderId])

    const fetchFolderById = async () => {
        try {
            dispatch(openLoader())
            const response = await getFolderById(`?folderId=${folderId}`)
            setFolderInfo(response)
            setFolderName(response?.name)
            setDescription(response?.description)
        } catch (error) {
            printApiError(error)
        } finally {
            dispatch(closeLoader())
        }
    }

    const handleCreate = async () => {
        try {
            dispatch(openLoader())
            if (folderId) {
                await updateFavouriteFolder(
                    `${folderId}/update?name=${encodeURIComponent(
                        folderName
                    )}&description=${description}`
                )
            } else {
                await addNewFavouriteFolder(
                    `?name=${encodeURIComponent(
                        folderName
                    )}&description=${description}`
                )
            }
            await fetchFolderList()
            dispatch(closeLoader())
            closeModal()
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    return (
        <>
            {(isShowModal || folderId) && (
                <ModalContainer
                    className='create-folder-modal'
                    onCloseModal={closeModal}
                >
                    <div className='common-popup'>
                        <div className='common-popup-header d-flex justify-content-between'>
                            <div className='popup-tilte'>
                                <h3 className='semibold-16 mb-0'>
                                    Create new folder
                                </h3>
                                <p className='regular-12 gray_300'>
                                    Create new folder in favorite
                                </p>
                            </div>
                            <div
                                className='close-btn cursor-pointer'
                                onClick={closeModal}
                            >
                                <CloseIcon />
                            </div>
                        </div>

                        <div className='common-popup-body p-4'>
                            <div className='form-group'>
                                <label className='regular-14 gray_300 mb-2'>
                                    Title
                                </label>

                                <input
                                    className={error ? 'required' : ''}
                                    type='text'
                                    name='title'
                                    placeholder=''
                                    value={folderName}
                                    onChange={(e) =>
                                        setFolderName(e.target.value)
                                    }
                                />
                            </div>
                            <div className='form-group'>
                                <label className='regular-14 gray_300 mb-2'>
                                    Description
                                </label>

                                <textarea
                                    placeholder='Write in details'
                                    className='h-20'
                                    onChange={(e) =>
                                        setDescription(e.target.value)
                                    }
                                    value={description}
                                ></textarea>
                            </div>
                        </div>
                        <div className='common-popup-footer'>
                            <button
                                className='button primary mr-3'
                                onClick={handleCreate}
                            >
                                <span>Create</span>
                            </button>
                            <button
                                className='button secondary'
                                onClick={closeModal}
                            >
                                <span>Close</span>
                            </button>
                        </div>
                    </div>
                </ModalContainer>
            )}
        </>
    )
}
export default AddFolderModal
